module.exports = __webpack_public_path__ + "img/news02-M01.e20079c9.jpg";